<script>
import { mapActions } from 'vuex'
import Layout from '@layouts/public.vue'
import { getLanguageBasedOnBaseURL } from '@/helpers/language-helpers'

export default {
  name: 'ImpersonateLogoutView',
  components: { Layout },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: '' }],
    }
  },
  async created() {
    await this.clearStore()
    window.location.href = `/${getLanguageBasedOnBaseURL()}/landing`
  },
  methods: {
    ...mapActions({
      clearStore: 'clearStore',
    }),
  },
}
</script>

<template>
  <Layout>
    <p>
      Redirecting...
      <a class="text-decoration-underline" :to="'/'">Click here</a> if you
      haven't been redirected automatically
    </p>
  </Layout>
</template>
